import { useTranslation } from 'react-i18next';
import { Divider, Stack, Typography } from '@mui/material';

import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { Section } from '@/modules/common/components/Section';
import { LodZoomInput } from './LodZoomInput';
import { HistoryDepthInput } from './HistoryDepthInput';
import { SnappingThresholdInput } from './SnappingThresholdInput';
import { ShowReleaseMessage } from '@/components/SettingsPanel/components/ShowReleaseMessage';
import { UserPreferenceName } from '@/modules/userPreferences';

type Props = {
  closeModal: () => void;
};

export const SettingsModal = ({ closeModal }: Props) => {
  const { t } = useTranslation();

  return (
    <Stack direction='column' spacing={2.5} sx={{ width: '100%', minWidth: 700 }}>
      <Typography variant='h3'>Settings</Typography>
      <Divider />
      <Stack direction='column' spacing={2.5} sx={{ width: '100%' }}>
        <Section title={t('interface:settings.sections.general')}>
          {/* <PropertiesLabel i18nkey='interface:settings.display' labelRatio={50}>
            <DarkModeSwitch />
          </PropertiesLabel> */}
          <PropertiesLabel i18nkey='interface:settings.show_release_notes' labelRatio={50}>
            <ShowReleaseMessage onClose={closeModal} />
          </PropertiesLabel>
        </Section>

        <Divider />

        <Section title={t('interface:settings.sections.editing')}>
          <PropertiesLabel
            i18nkey='interface:settings.history_depth'
            infoI18nKey='interface:settings.history_depth_info'
            labelRatio={50}
          >
            <HistoryDepthInput />
          </PropertiesLabel>
          <PropertiesLabel
            i18nkey='interface:settings.snapping_threshold'
            infoI18nKey='interface:settings.snapping_threshold_info'
            labelRatio={50}
          >
            <SnappingThresholdInput />
          </PropertiesLabel>
        </Section>

        <Divider />

        <Section title={t('interface:settings.sections.level_of_detail')}>
          <PropertiesLabel i18nkey='interface:settings.lod.bubbles_zoom' labelRatio={50}>
            <LodZoomInput preference={UserPreferenceName.LOD_BUBBLES_ZOOM_THRESHOLD} />
          </PropertiesLabel>
          <PropertiesLabel i18nkey='interface:settings.lod.boxes_zoom' labelRatio={50}>
            <LodZoomInput preference={UserPreferenceName.LOD_BOXES_ZOOM_THRESHOLD} />
          </PropertiesLabel>
          <PropertiesLabel i18nkey='interface:settings.lod.vehicle_layouts_zoom' labelRatio={50}>
            <LodZoomInput preference={UserPreferenceName.LOD_VEHICLE_LAYOUTS_ZOOM_THRESHOLD} />
          </PropertiesLabel>
          <PropertiesLabel i18nkey='interface:settings.lod.tracks_zoom' labelRatio={50}>
            <LodZoomInput preference={UserPreferenceName.LOD_TRACKS_ZOOM_THRESHOLD} />
          </PropertiesLabel>
        </Section>

        <Divider />
      </Stack>
    </Stack>
  );
};
